"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymousClient = void 0;
const BaseClient_1 = require("../BaseClient");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class AnonymousClient extends BaseClient_1.BaseClient {
    constructor(app, entity, baseUrl) {
        super(baseUrl);
        this.app = app;
        this.entity = entity;
    }
    async storageGet(id) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/anonymous/storage/get',
            params: {
                app: this.app,
                entity: this.entity,
                id: id,
            },
        });
        return response.data;
    }
    async storageList(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/anonymous/storage/list',
            data: {
                ...request,
                app: this.app,
                entity: this.entity,
            },
        });
        return response.data;
    }
    async storageListColumns(request, ...columns) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/anonymous/storage/listColumns',
            data: {
                ...request,
                app: this.app,
                entity: this.entity,
                columns: columns,
            },
        });
        return response.data;
    }
    async storageListParents(id, includeSelf) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/anonymous/storage/listParents',
            params: {
                app: this.app,
                entity: this.entity,
                id: id,
                includeSelf: includeSelf,
            },
        });
        return response.data;
    }
    /**
     * Convenience method to get count of rows by filter
     */
    async storageCount(request) {
        const response = await this.storageList({ filter: request.filter, limit: 0 });
        return response.total;
    }
    async storagePost(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/anonymous/storage/post',
            data: {
                ...request,
                app: this.app,
                entity: this.entity,
            },
        });
        return response.data;
    }
    async executeFunction(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/anonymous/function',
            params: {
                app: this.app,
            },
            data: request,
        });
        return response.data;
    }
}
exports.AnonymousClient = AnonymousClient;
